import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"right","margin-bottom":"10px"} }
const _hoisted_2 = { style: {"margin-left":"10px"} }

import { unref, reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';

import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { useAppStore } from '@/store/app';
import { findIndex, formatTools } from '@/utils';
import { Session } from '@/utils/storage';
import { config } from '@/config/config';
import { GetMaterialListApi } from '@/apis/contract/contract.draft.api';
import { DelMaterialsApi } from '@/apis/materials/material.api';
import PdfViewDialog from '@/views/contracts/editors/components/pdfViewDialog.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    ctId: null
  },
  setup(__props: any, { expose }) {


const pdfViewRef = ref<InstanceType<typeof PdfViewDialog>>();

const { t } = useLocales();
const dicStore = useDictionary();
const login = useAppStore().getLoginInfo;
const { register, tableObject } = useGbTable();
const { fDateTime } = formatTools();
const { base_url } = config;
const { resolve } = useRouter();

const tabColumns = reactive<any[]>([
	{ field: 'file_name', label: t('billMaterialList.table.fileName', '文件名称') },
	{ field: 'material_type_desc', label: t('billMaterialList.table.category', '分类'), columnWidth: '100', align: 'center' },
	{ field: 'file_suffix', label: t('billMaterialList.table.fileType', '文件类型'), columnWidth: '80', headerAlign: 'center', align: 'center' },
	{ field: 'file_size', label: t('billMaterialList.table.fileSize', '文件大小'), columnWidth: '120', headerAlign: 'center', align: 'right' },
	{ field: 'created_user_id', label: t('billMaterialList.table.uploadUser', '上传用户'), columnWidth: '120', align: 'center' },
	{ field: 'created_time', label: t('billMaterialList.table.uploadTime', '上传时间'), columnWidth: '120', align: 'center' },
	{ field: 'action', width: '120px', label: t('billMaterialList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
	load: false,
	materialTypeList: [] as any[],
});

const upSchema = ref<any>({
	categroy_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e',
	ct_id: '',
	ct_num: '',
	material_type: '',
	material_type_desc: '',
});

const uploads = {
	urls: `${base_url}/api/sysmaterial/uploadfile`,
	headers: {
		Authorization: '',
	},
	onUploadSuccess: (res: IResponse, file: any) => {
		if (!res.succeeded) {
			ElMessage.error(`${t('material.message.uploadFailed', '文件上传失败，可能的原因是：')}${res.errors}`);
		} else {
			ElMessage.success(t('material.message.uploadSuccess', '上传成功'));
			tableObject.tableList.push(res.data);
		}
	},
};

const actions = {
	preview: (row: any) => {
		if (row.file_suffix != '.pdf') {
			const isOfficeFile = ['.doc', '.docx', 'text', '.xls', 'xlsx'].indexOf(row.file_suffix) > 0;
			if (isOfficeFile) {
				let urls = resolve({ path: `/onlyoffices/docview/${row.id}/1` });
				window.open(urls.href, '_blank');
			} else {
				window.open(row.file_url, '_blank');
			}
		} else {
			unref(pdfViewRef)?.openDialog(row);
		}
	},
	deleteFile: (row: any) => {
		if (row.created_user_id !== login.user_account) {
			ElMessage.warning(t('contracts.noPermissionDelSupplement', '只能删除自己上传的补充附件'));
			return;
		}
		const rowIndex = findIndex<any>(tableObject.tableList, (tt: any) => tt.id == row.id);
		if (rowIndex < 0) return;

		const delData = { id: row.id, revision: row.revision };
		ElMessageBox.confirm(t('material.message.deleteConfirm', '是否删除选中的数据？'), t('buttons.preview', '提示'), {
			confirmButtonText: t('buttons.submit', '确定'),
			cancelButtonText: t('buttons.cancel', '取消'),
			type: 'warning',
			lockScroll: false,
		}).then(async () => {
			await DelMaterialsApi(delData).then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`${t('material.message.deleteFailed', '附件删除失败，原因：')}${res.errors}`);
				} else {
					ElMessage.success(t('material.message.deleteSuccess', '删除成功。'));
					tableObject.tableList.splice(rowIndex, 1);
				}
			});
		});
	},
	canDelete: (row: any) => row.created_user_id === login.user_account,
};

const changes = {
	materialtype: (val: any) => {
		unref(upSchema).material_type_desc = dicStore.getName('material_type', val) || '--';
	},
};

const methods = {
	setFileList: async (contractId: string) => {
		state.load = true;
		unref(upSchema).ct_id = contractId;
		const { succeeded, errors, data } = await GetMaterialListApi(contractId);
		state.load = false;
		if (!succeeded) {
			ElMessage.error(`${t('material.message.loadMaterialListError', '读取附件列表出错，可能的原因是：')}${errors}`);
		} else {
			tableObject.tableList = data || [];
		}
	},
};

onMounted(() => {
	state.materialTypeList = dicStore.getSelectList('material_type');
	const defType = state.materialTypeList.filter((tp: any) => tp.label == '合同正本') || [];
	if (defType.length == 1) {
		unref(upSchema).material_type = defType[0].value;
		unref(upSchema).material_type_desc = defType[0].label;
	}
	const tokenStr = Session.get('token') as string;
	const token = (str: any) => {
		try { return JSON.parse(str); } catch (e) { return str; }
	};
	uploads.headers.Authorization = `Bearer ${token(tokenStr)}`;
});

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_upload, {
        data: upSchema.value,
        action: uploads.urls,
        headers: uploads.headers,
        "show-file-list": false,
        "on-success": uploads.onUploadSuccess
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: upSchema.value.material_type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((upSchema.value.material_type) = $event)),
            class: "mgr-10",
            style: {"width":"120px"},
            onChange: changes.materialtype
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).materialTypeList, (tps) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: tps.label,
                  value: tps.value
                }, null, 8, ["label", "value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('contracts.uploadSupplement', '上传补充附件')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["data", "action", "headers", "on-success"])
    ]),
    _createVNode(_unref(GbTables), {
      data: _unref(tableObject).tableList,
      columns: _unref(tabColumns),
      "show-paged": false,
      onRegister: _unref(register)
    }, {
      created_time: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(fDateTime)(row.created_time)), 1)
      ]),
      material_type_desc: _withCtx(({ row }) => [
        _createVNode(_component_el_tag, {
          size: "small",
          type: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(row.material_type_desc), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      action: _withCtx(({ row }) => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          link: "",
          onClick: ($event: any) => (actions.preview(row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('billMaterialList.buttons.preview', '预 览')), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]),
        (actions.canDelete(row))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "small",
              type: "danger",
              link: "",
              onClick: ($event: any) => (actions.deleteFile(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.delete', '删 除')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data", "columns", "onRegister"]),
    _createVNode(PdfViewDialog, {
      ref_key: "pdfViewRef",
      ref: pdfViewRef
    }, null, 512)
  ], 64))
}
}

})